import { Box, CircularProgress } from '@mui/material';

export default function Loader() {
  return (
    <Box display={'flex'} justifyContent='center' alignItems={'center'} height='100%' py={5}>
      <CircularProgress />
    </Box>
  );
}
